import { render, staticRenderFns } from "./NewsPreviewModal.vue?vue&type=template&id=8afcff3e&scoped=true&"
import script from "./NewsPreviewModal.vue?vue&type=script&lang=ts&"
export * from "./NewsPreviewModal.vue?vue&type=script&lang=ts&"
import style0 from "./NewsPreviewModal.vue?vue&type=style&index=0&id=8afcff3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8afcff3e",
  null
  
)

export default component.exports